export const CHANGE_MAINTENANCE_FLAG = 'CHANGE_MAINTENANCE_FLAG';

export const changeMaintenanceFlag = flag => ({
  type: CHANGE_MAINTENANCE_FLAG,
  flag,
});
